let autoScrollInterval;

function startAutoScroll() {
  clearInterval(autoScrollInterval);
  autoScrollInterval = setInterval(goToNextSlide, 5000);
}

function stopAutoScroll() {
  clearInterval(autoScrollInterval);
}

function checkAndToggleAutoScroll() {
  const anyVideoPlaying = Array.from(document.querySelectorAll("video")).some(
    (video) => !video.paused
  );
  const anyReadMoreExpanded = Array.from(
    document.querySelectorAll(".desc-story")
  ).some((desc) => desc.classList.contains("expanded"));

  if (anyVideoPlaying || anyReadMoreExpanded) {
    stopAutoScroll();
  } else {
    startAutoScroll();
  }
}

function updateButtonText(button, video) {
  if (video.muted) {
    button.textContent = "Unmute";
  } else {
    button.textContent = "Mute";
  }
}

function muteAllVideos() {
  document.querySelectorAll("video").forEach(function (video) {
    video.muted = true;
    video.currentTime = 0; // Optional: Reset video playback time
  });
}

function collapseAllDescriptions() {
  document.querySelectorAll(".desc-story.expanded").forEach(function (desc) {
    desc.classList.remove("expanded");
    desc.closest(".story").querySelector(".read-more").textContent =
      "Read more";
  });
}

// MUTE & UNMUTE
document.querySelectorAll(".mute").forEach(function (muteBtn) {
  muteBtn.addEventListener("click", function () {
    const video = this.closest(".story").querySelector("video");

    if (video.muted) {
      video.muted = false;
      if (video.paused) {
        video.play();
      }
    } else {
      video.muted = true;
      video.currentTime = 0;
    }

    updateButtonText(this, video);
    checkAndToggleAutoScroll(); // Check and update auto-scroll status
  });

  const video = muteBtn.closest(".story").querySelector("video");
  updateButtonText(muteBtn, video);
});

// READ MORE
document.querySelectorAll(".read-more").forEach(function (readMoreBtn) {
  readMoreBtn.addEventListener("click", function () {
    const storyDesc = this.closest(".story").querySelector(".desc-story");
    const isExpanded = storyDesc.classList.contains("expanded");

    if (isExpanded) {
      storyDesc.classList.remove("expanded");
      this.textContent = "Read more";
      startAutoScroll();
    } else {
      storyDesc.classList.add("expanded");
      this.textContent = "Read less";
      stopAutoScroll();
    }
    checkAndToggleAutoScroll(); // Check and update auto-scroll status
  });
});

// STORY SLIDER
document.addEventListener("DOMContentLoaded", function () {
  const prevButton = document.querySelector(".prev");
  const nextButton = document.querySelector(".next");
  const wrapper = document.querySelector(".carousel-wrapper");
  const slides = document.querySelectorAll(".carousel-slide");
  const totalSlides = slides.length;
  let currentIndex = 0;

  function showSlide(index) {
    const offset = -index * 100;
    if (wrapper) {
      wrapper.style.transform = `translateX(${offset}%)`;
    }
  }

  function goToNextSlide() {
    currentIndex = (currentIndex + 1) % totalSlides;
    showSlide(currentIndex);
    muteAllVideos(); // Mute all videos when changing slides
    collapseAllDescriptions(); // Collapse all expanded descriptions when changing slides
  }

  prevButton?.addEventListener("click", function () {
    currentIndex = currentIndex === 0 ? totalSlides - 1 : currentIndex - 1;
    showSlide(currentIndex);
    muteAllVideos(); // Mute all videos when changing slides
    collapseAllDescriptions(); // Collapse all expanded descriptions when changing slides
  });

  nextButton.addEventListener("click", function () {
    goToNextSlide();
  });

  // Initialize the first slide
  showSlide(currentIndex);

  // Start auto-scroll initially
  startAutoScroll();

  // Add event listeners to handle video state changes
  document.querySelectorAll("video").forEach(function (video) {
    video.addEventListener("play", checkAndToggleAutoScroll);
    video.addEventListener("pause", checkAndToggleAutoScroll);
  });
});
